import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import ElementUI from 'element-ui'
import 'core-js/stable'
import axios from 'axios'
import moment from 'moment'
// moment插件
import 'moment-duration-format'
import './interceptors'

Vue.prototype.$moment = moment
// ajax 请求库， 使在每个vue组件中能使用 this.$http 请求
Vue.prototype.$http = axios
// 注册路由
Vue.use(VueRouter)
// 注册状态
Vue.use(Vuex)
// 使用 element-ui 作为ui组件
Vue.use(ElementUI, {
  size: 'small',
  zIndex: 30000
})
// 将库都吐出去。
export { Vue, VueRouter, Vuex, axios }
